export default "__VITE_ASSET__CdkM19K0__"